import { ThemeEvents } from '@theme/events';

class AvtProductContextLink extends HTMLElement {
  #abortController = null;

  connectedCallback() {
    this.#abortController?.abort();
    this.#abortController = new AbortController();
    const section = this.closest('.shopify-section');
    section?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate, {
      signal: this.#abortController.signal,
    });
  }

  disconnectedCallback() {
    this.#abortController?.abort();
  }

  #handleVariantUpdate = (event) => {
    if (String(event.detail?.data?.productId ?? '') !== this.dataset.productId) return;

    const link = this.querySelector('[data-avt-product-context-link]');
    if (!(link instanceof HTMLAnchorElement)) return;

    const url = new URL(link.href);
    url.searchParams.set('sku', String(event.detail?.resource?.sku ?? ''));
    link.href = url.href;
  };
}

if (!customElements.get('avt-product-context-link')) {
  customElements.define('avt-product-context-link', AvtProductContextLink);
}
